import ErrorHandler from "../error-handlers/axios/defaultErrorHandler";

/**
 * @typedef {Object} Submission
 * @property {string} _id
 * @property {string} contact
 * @property {string} leadEnquiry
 * @property {string} leadSource
 * @property {string} fullname
 * @property {string} phone
 * @property {string} utm_source
 * @property {string} utm_medium
 * @property {string} utm_campaign
 * @property {string} utm_term
 * @property {string} utm_content
 * @property {string} submission_time
 */

/**
 * @description Fetches a list of campaign submissions
 * @param {Axios} axiosInstance
 * @param {import("axios").AxiosRequestConfig} options
 * @returns {Promise<Array<Submission>>} apiResponse
 */
export const fetchSubmissions = async (axiosInstance, options) => {
    try {
        const res = await axiosInstance.get(`/reports/submissions`, options);

        return res?.data;
    } catch (error) {
        ErrorHandler.handle(error);
    }
};